// Web Share API → clipboard → plain-toast fallback chain, ported verbatim.
export async function shareGameCode(code: string, showToast: (msg: string, duration?: number) => void) {
  const url = `${window.location.origin}/join/${code}`;

  const shareData = {
    title: 'Join my Alphabet Hunter game!',
    text: `Hey! Join my Alphabet Hunter game 🎮  Code: ${code}`,
    url,
  };

  if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
    try {
      await navigator.share(shareData);
      return;
    } catch (e) {
      if ((e as Error).name === 'AbortError') return; // user dismissed
    }
  }

  const fallbackText = `Join my Alphabet Hunter game! Code: ${code} — ${url}`;
  try {
    await navigator.clipboard.writeText(fallbackText);
    showToast('Copied! Paste it into any message app.', 3500);
  } catch {
    showToast(`Game code: ${code}`, 6000);
  }
}
